enum ForecastStatus {
  NEW = 'NEW',
  EDITABLE = 'EDITABLE',
  FROZEN = 'FROZEN'
}

export default ForecastStatus;
